module.exports = __webpack_public_path__ + "img/image 11.12bd52bd.png";